var map = {
	"./de.json": 25992,
	"./en.json": 46210,
	"./es.json": 96013,
	"./fr.json": 31441,
	"./he.json": 81873,
	"./ja.json": 55233,
	"./no.json": 78432,
	"./zh-CN.json": 54163,
	"./zh-TW.json": 69271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68551;